import React from 'react';
import Button from 'components/ContentfulFields/Button';
import imgPorchDelivery from './porch-delivery.png';
import styles from './styles.scss';

const URL = 'https://www.water.com';

const GetDelivery = () => (
  <article className={styles.getDelivery}>
    <figure>
      <img
        src={imgPorchDelivery}
        alt="Woman bringing in 5-gallon bottles from the porch."
      />
    </figure>
    <div className={styles.text}>
      <h2>Water Delivery</h2>
      <h3>Enjoy the convenience of bottled water delivery</h3>
      <p>
        We deliver bottled water and beverages in a wide selection of flavors
        and the world-class brand name products you've come to love.
      </p>
      <Button to={URL} text="Get Water Delivery" className={styles.btn} />
    </div>
  </article>
);

export default GetDelivery;
